import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Accordion } from "./Accordion/Accordion";
import AlbumAccordion from "./Album/AlbumAccordion";
import Autorizados from "./Album/Autorizados";
import { albumKeysSorted } from "../utils/figuritas";
import {
  getCantidadFiguritas,
  getCantidadFiguritasEstado,
} from "../utils/figuritas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faCloud } from "@fortawesome/free-solid-svg-icons";
import IndexPill from "./IndexPill";
import SharePill from "./SharePill";

export default function AlbumMainContainer() {
  const [update, setUpdate] = useState(false);
  const [numeroLate, setNumeroLate] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const figuritas = useSelector((state) => state.figuritasReducer.figuritas);
  const currentUser = useSelector((state) => state.currentUser.user);
  const sortFiguritas = (status, lateStatus = "") => {
    const figuritasList = { ...figuritas?.album };
    if (figuritasList) {
      albumKeysSorted(figuritasList).forEach((key) => {
        const sortedKeyList = figuritasList[key]
          .sort((a, b) => {
            return a.numero - b.numero;
          })
          .filter(
            (figurita) =>
              figurita.estado === status || figurita.estado === lateStatus
          );
        return (figuritasList[key] = sortedKeyList);
      });
    }
    return figuritasList;
  };

  useEffect(() => {
    if (figuritas) {
      setNumeroLate(getCantidadFiguritas(figuritas?.album));
    }
  }, [figuritas]);

  useEffect(() => {
    setTimeout(() => {
      setPercentage(((numeroLate * 100) / 638).toFixed(1));
    }, 500);
  }, [numeroLate]);

  const figuritasLate = useMemo(() => {
    return sortFiguritas("late", "repe");
  }, [figuritas]);
  const figuritasRepe = useMemo(() => {
    return sortFiguritas("repe");
  }, [figuritas]);

  const figuritasNola = useMemo(() => {
    return sortFiguritas("nola");
  }, [figuritas]);
  return (
    <div className="rightMenu">
      {figuritas && (
        <>
          {!update ? (
            <div className="headerContainerAlbum">
              <div className="sync-status">
                <FontAwesomeIcon icon={faCloud} />
                <p>Guardado</p>
              </div>
              <div>
                <a
                  href="https://cafecito.app/digital-album"
                  rel="noopener"
                  target="_blank"
                >
                  <img
                    srcset="https://cdn.cafecito.app/imgs/buttons/button_5.png 1x, https://cdn.cafecito.app/imgs/buttons/button_5_2x.png 2x, https://cdn.cafecito.app/imgs/buttons/button_5_3.75x.png 3.75x"
                    src="https://cdn.cafecito.app/imgs/buttons/button_5.png"
                    alt="Invitame un café en cafecito.app"
                  />
                </a>
              </div>
            </div>
          ) : (
            <div className="sync-status">
              <FontAwesomeIcon icon={faRotate} className="rotate-sync" />
              <p>Guardando...</p>
            </div>
          )}
          <h1>Álbum de {figuritas.owner.name}</h1>
          <div className="career-progress-container">
            <span>
              {`${
                percentage < 0 || percentage > 100 || percentage === "NaN"
                  ? 0
                  : percentage
              }% completado`}
            </span>
            <div
              className="career-progress-bar"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <Accordion
            title={
              <>
                <strong>Álbum</strong>
                <span className="indexPills">
                  <IndexPill number="Repes" estado="repe" />
                </span>
                <span>{`${getCantidadFiguritas(figuritas?.album)}/638`}</span>
              </>
            }
          >
            <AlbumAccordion
              accordion="album"
              figuritasSorted={figuritas?.album}
              updating={(value) => setUpdate(value)}
              update={update}
            />
          </Accordion>
          <Accordion
            title={
              <>
                <strong>Repes</strong>
                <span className="sharePills">
                  <SharePill number="Repes" estado="repe" />
                </span>
                <span>{`${getCantidadFiguritasEstado(
                  figuritas?.album,
                  "repe"
                )}`}</span>
              </>
            }
          >
            <AlbumAccordion
              accordion="repe"
              figuritasSorted={figuritasRepe}
              updating={(value) => setUpdate(value)}
              update={update}
            />
          </Accordion>
          <Accordion
            title={
              <>
                <strong>Lates</strong>
                <span>{`${getCantidadFiguritas(figuritas?.album)}`}</span>
              </>
            }
          >
            <AlbumAccordion
              accordion="late"
              figuritasSorted={figuritasLate}
              updating={(value) => setUpdate(value)}
              update={update}
            />
          </Accordion>
          <Accordion
            title={
              <>
                <strong>Nolas</strong>
                <span className="sharePills">
                  <SharePill estado="nola" />
                </span>
                <span>{`${getCantidadFiguritasEstado(
                  figuritas?.album,
                  "nola"
                )}`}</span>
              </>
            }
          >
            <AlbumAccordion
              accordion="nola"
              figuritasSorted={figuritasNola}
              updating={(value) => setUpdate(value)}
              update={update}
            />
          </Accordion>
          {(figuritas.owner.uid === currentUser.uid ||
            figuritas.autorizados.find(
              (autorizado) =>
                autorizado.email === currentUser.email && autorizado.editar
            )) && <Autorizados />}
        </>
      )}
    </div>
  );
}
